import * as farmActions from './farmActions'
import * as fieldActions from './fieldActions'
import * as growerActions from './growerActions'

import { Collapse } from '@atd/rui-base.mui.collapse'
import { ListItem } from '@atd/rui-base.mui.list-item'
import { ListItemText } from '@atd/rui-base.mui.list-item-text'

import AddIcon from '@mui/icons-material/Add'
import { Button } from '@atd/rui-base.mui.button'
import { IconButton } from '@atd/rui-base.mui.icon-button'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import EmptyState from '../commonComponents/emptyState'
import FarmCard from './farmCard'
import FarmEdit from './farmedit'
import FieldCard from './fieldCard'
import FieldEdit from './fieldedit'
import GrowerCard from './growerCard'
import GrowerCardLoader from './growerCardLoader'
import GrowerEdit from './groweredit'
import ListPaging from '../commonComponents/listPaging'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { farmPrototype } from './farmDataPrototype'
import { fieldPrototype } from './fieldDataPrototype'
import { growerPrototype } from './growerDataPrototype'

import './gffStyles.css'

function mapStateToProps(state, ownProps) {
    return {
        growers: state.gff.growers,
        farms: state.gff.farms,
        fields: state.gff.fields,
        isFetching: state.gff.isFetching,
        selectedCompanyId: state.admin.selectedCompanyId,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(growerActions, dispatch),
        ...bindActionCreators(farmActions, dispatch),
        ...bindActionCreators(fieldActions, dispatch),
    }
}

let gffListItems = []
const growerListItems = []
const farmListItems = []
const fieldListItems = []

// default text when no GFF have been created
growerListItems.push(<ListItem key={-1}><ListItemText primary="No Grower"/></ListItem>)
farmListItems.push(<ListItem key={-1}><ListItemText primary="No Farm"/></ListItem>)
fieldListItems.push(<ListItem key={-1}><ListItemText primary="No Field"/></ListItem>)

class GffViewer extends React.Component {
    componentDidMount() {
        this.props.fetchGrowers()
        this.props.fetchFarms()
        this.props.fetchFields()
    }

    state = {
        addState: '',
        tempGffItem: {},
        viewList: [],
        expanded: {},
    }
    getDisabled = () => {
        return !this.props.selectedCompanyId
    }

    onViewListChanged = (newList) => {
        this.setState({viewList: [...newList]})
    }
    toggleExpand = (key) => {
        this.setState(prev => ({ expanded: { ...prev.expanded, [key]: !prev.expanded[key] } }))
    }
    renderCardRow = (card, hasChildren, expanded, onToggle, depth = 0) => {
        return (
            <div className="gffCardRow" style={{ marginLeft: depth * 24 }}>
                {card}
                {hasChildren && (
                    <IconButton
                        className="gffExpandButton"
                        onClick={onToggle}
                        aria-label={expanded ? 'collapse' : 'expand'}
                        name="toggleChildren">
                        {expanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                    </IconButton>
                )}
            </div>
        )
    }
    createGrowerItem = (data, i) => {
        const growerChildren = this.props.farms.filter(farm => farm.growerId === data.id)
        const key = `grower-${data.id}`
        const expanded = Boolean(this.state.expanded[key])

        return (
            <React.Fragment key={data.id}>
                {this.renderCardRow(
                    <GrowerCard
                        data={data}
                        disabled={this.getDisabled()}
                        addFarm={this.addFarm}
                    />,
                    growerChildren.length > 0,
                    expanded,
                    () => this.toggleExpand(key),
                    0,
                )}
                {growerChildren.length > 0 && (
                    <Collapse in={expanded} timeout={150} unmountOnExit>
                        {growerChildren.map(this.createFarmItem)}
                    </Collapse>
                )}
            </React.Fragment>
        )
    }

    createFarmItem = (data, i) => {
        const farmChildren = this.props.fields.filter(field => field.farmId === data.id)
        const key = `farm-${data.id}`
        const expanded = Boolean(this.state.expanded[key])

        return (
            <React.Fragment key={data.id}>
                {this.renderCardRow(
                    <FarmCard
                        data={data}
                        disabled={this.getDisabled()}
                        addField={this.addField}
                    />,
                    farmChildren.length > 0,
                    expanded,
                    () => this.toggleExpand(key),
                    1,
                )}
                {farmChildren.length > 0 && (
                    <Collapse in={expanded} timeout={150} unmountOnExit>
                        {farmChildren.map(this.createFieldItem)}
                    </Collapse>
                )}
            </React.Fragment>
        )
    }

    createFieldItem = (data, i) => {
        return (
            <React.Fragment key={data.id}>
                {this.renderCardRow(
                    <FieldCard
                        data={data}
                        disabled={this.getDisabled()}
                    />,
                    false,
                    false,
                    null,
                    2,
                )}
            </React.Fragment>
        )
    }

    addGrower = () => {
        this.setState({
            addState: 'grower',
            tempGffItem: new growerPrototype(''),
        })
    }
    saveGrower = newData => {
        this.props.addGrower(newData)
        this.setState({ addState: '', tempGffItem: {} })
    }

    addFarm = growerId => {
        this.setState({
            addState: 'farm',
            tempGffItem: new farmPrototype(growerId, ''),
        })
    }
    saveFarm = newData => {
        this.props.addFarm(newData)
        this.setState({ addState: '', tempGffItem: {}})
    }

    addField = (growerId, farmId) => {
        this.setState({
            addState: 'field',
            tempGffItem: new fieldPrototype(growerId, farmId, ''),
        })
    }
    saveField = newData => {
        this.props.addField(newData)
        this.setState({ addState: '', tempGffItem: {} })
    }

    cancelAdd = () => {
        this.setState({ addState: '', tempGffItem: {} })
    }
    getAddDialog = () => {
        if (this.state.addState === 'grower') {
            return (
                <GrowerEdit
                    data={this.state.tempGffItem}
                    onCancel={this.cancelAdd}
                    onSubmit={this.saveGrower}
                    open={true}
                />
            )
        }
        else if (this.state.addState === 'farm') {
            return (
                <FarmEdit
                    data={this.state.tempGffItem}
                    onCancel={this.cancelAdd}
                    onSubmit={this.saveFarm}
                    open={true}
                />
            )
        }
        else if (this.state.addState === 'field') {
            return (
                <FieldEdit
                    data={this.state.tempGffItem}
                    onCancel={this.cancelAdd}
                    onSubmit={this.saveField}
                    open={true}
                />
            )
        }

        return ''
    }

    renderEmptyState = () => {
        return (
            <EmptyState>
                <h3>No Growers Found</h3>
                <div style={{ width: '100%', maxWidth: 700, margin: 'auto' }}>
                    <Button variant="contained"
                        disabled={this.getDisabled()}
                        startIcon={<AddIcon htmlColor="white" />}
                        onClick={this.addGrower}
                        color="primary">Add Grower</Button>
                    {this.getAddDialog()}
                </div>
            </EmptyState>
        )
    }

    renderLoadingState = () => {
        return (
            <>
                <Button variant="contained"
                    disabled={true}
                    startIcon={<AddIcon />}>Add Grower</Button>
                <div name="loadingList">
                    {Array(10).fill().map((item, index) => (
                        <div className="gffCardRow" key={index}><GrowerCardLoader/></div>
                    ))}
                </div>
            </>
        )
    }

    renderGffList = (gffListItems) => {
        return (
            <>
                <Button variant="contained"
                    disabled={this.getDisabled()}
                    startIcon={<AddIcon htmlColor="white" />}
                    onClick={this.addGrower}
                    color="primary">Add Grower</Button>
                <div name="gffList">
                    {gffListItems}
                </div>
                <ListPaging
                    disabled={this.getDisabled()}
                    itemList={this.props.growers || []}
                    viewListChanged={this.onViewListChanged}
                />
                {this.getAddDialog()}
            </>
        )
    }

    render() {
        const visibleGrowers = this.state.viewList.length ? this.state.viewList : (this.props.growers || []).slice(0, 10)
        gffListItems = visibleGrowers.map(this.createGrowerItem)

        return (
            <div style={{ width: '100%', maxWidth: 700, margin: 'auto' }}>
                {!this.props.isFetching && this.props.growers.length === 0 && this.renderEmptyState()}
                {this.props.isFetching && this.renderLoadingState()}
                {!this.props.isFetching && this.props.growers.length > 0 && this.renderGffList(gffListItems)}
            </div>
        )
    }
}

// be sure to connect the component to the Redux state so it can use it!
export default connect(mapStateToProps, mapDispatchToProps)(GffViewer)
